/**
 * <s-back-link> wraps a plain link to the homepage. When the shopper arrived
 * from another page on this store, a click goes back one step in history
 * instead; otherwise the link's own href (homepage) is followed.
 */
class BackLinkElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('a')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    let cameFromStore = false;
    try {
      cameFromStore = document.referrer !== '' && new URL(document.referrer).origin === window.location.origin;
    } catch {
      cameFromStore = false;
    }

    if (cameFromStore && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  };
}

if (!customElements.get('s-back-link')) {
  customElements.define('s-back-link', BackLinkElement);
}
